export default __webpack_public_path__ + "static/media/card4.068c6c3c.svg";